import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../../../../../Constants";

const DispatchesModal = ({ isOpen, onClose, callNumber }) => {
    const [dispatches, setDispatches] = useState([]);
    const [actionItems, setActionItems] = useState([]);

    useEffect(() => {

        if(!callNumber) return;

        const fetchActionItems = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/callcenter/actionitems/call/${callNumber}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include'
                });
                const data = await response.json();
                setActionItems(data);
            } catch (error) {

                console.error("Error fetching action items:", error);
            }
        };
        fetchActionItems();
    }, [callNumber]);



    useEffect(() => {
        if (!isOpen || actionItems.length === 0) return;

        const fetchDispatches = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/dispatch-records/call/${callNumber}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include'
                });

                const data = await response.json();

                const dispatchesWithMappedItems = data.map(dispatch => {
                    const mappedItems = dispatch.actionItems.map(dispatchItem => {
                        const fullItem = actionItems.find(item => item.itemId === dispatchItem.itemId);
                        return {
                            ...fullItem,
                            isCompleted: dispatchItem.isCompleted
                        };
                    });

                    return {
                        ...dispatch,
                        actionItems: mappedItems
                    };
                });

                setDispatches(dispatchesWithMappedItems);
            } catch (error) {
                console.error("Error fetching dispatches:", error);
            }
        };

        fetchDispatches();
    }, [isOpen, callNumber, actionItems]);

    return (
        <div className={`fixed inset-0 bg-black bg-opacity-30 mt-20 flex justify-center items-center ${isOpen ? "z-50" : "hidden"}`}>
            <div className="bg-white rounded-xl shadow-2xl w-11/12 max-w-5xl flex flex-col max-h-[80vh]">
                {/* Scrollable Content */}
                <div className="p-6 overflow-y-auto flex-1">
                    <div className="sticky top-0 bg-white z-10 pb-2">
                        <h2 className="text-2xl font-bold border-b pb-2">
                            Dispatches for Call #{callNumber}
                        </h2>
                    </div>

                    <div className="flex flex-col gap-6 mt-4">
                        {dispatches.length === 0 ? (
                            <p className="text-center text-gray-600">
                                No dispatch records found for this call.
                            </p>
                        ) : (
                            dispatches.map((dispatch) => (
                                <div
                                    key={dispatch.dispatchRecordId}
                                    className="border rounded-lg p-5 shadow hover:shadow-md transition"
                                >
                                    <div className="mb-2">
                                        <h3 className="text-lg font-semibold text-blue-600">
                                            Dispatch ID: {dispatch.dispatchRecordId}
                                        </h3>
                                        <p>
                                            <span className="font-medium">Type:</span> {dispatch.type}
                                        </p>
                                        <p>
                                            <span className="font-medium">Start:</span>{" "}
                                            {new Date(dispatch.startDateTime).toLocaleString()}
                                        </p>
                                        <p>
                                            <span className="font-medium">End:</span>{" "}
                                            {new Date(dispatch.endDateTime).toLocaleString()}
                                        </p>
                                        <p>
                                            <span className="font-medium">Comments:</span>{" "}
                                            {dispatch.comments || "N/A"}
                                        </p>
                                        <p>
                                            <span className="font-medium">Signature Time:</span>{" "}
                                            {new Date(dispatch.signatureDateTime).toLocaleString()}
                                        </p>
                                    </div>

                                    <div className="mt-4">
                                        <h4 className="font-semibold mb-2">Action Items:</h4>
                                        {dispatch.actionItems.length > 0 ? (
                                            <ul className="space-y-2">
                                                {dispatch.actionItems.map((item) => (
                                                    <li
                                                        key={item.itemId}
                                                        className="bg-gray-50 p-3 rounded border"
                                                    >
                                                        <p>
                                                            <strong>Item ID:</strong> {item.itemId}
                                                        </p>
                                                        <p className="text-sm text-gray-700">
                                                            <strong>Status:</strong>{" "}
                                                            {item.isCompleted ? "✅ Completed" : "⏳ Pending"}
                                                        </p>
                                                        <p className="text-sm">
                                                            <strong>Problem:</strong> {item.problemClass} -{" "}
                                                            {item.problemSubClass}
                                                        </p>
                                                        <p className="text-sm">
                                                            <strong>Description:</strong> {item.description}
                                                        </p>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-sm text-gray-500">
                                                No action items available.
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* Fixed Button */}
                <div className="border-t px-6 py-4 bg-white">
                    <button
                        onClick={onClose}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DispatchesModal;